// extracted by mini-css-extract-plugin
export default {"dropdownMenuToggle":"DropdownMenuToggle_dropdownMenuToggle__XBGnO"};